export enum Process {
  view_taskresult = 'view_taskresult',
  add_socialtoken = 'add_socialtoken',
  view_periodictasks = 'view_periodictasks',
  change_periodictasklog = 'change_periodictasklog',
  delete_socialapp = 'delete_socialapp',
  add_department = 'add_department',
  change_accesslog = 'change_accesslog',
  add_chordcounter = 'add_chordcounter',
  view_chordcounter = 'view_chordcounter',
  delete_tokenproxy = 'delete_tokenproxy',
  change_departmentteam = 'change_departmentteam',
  add_clockedschedule = 'add_clockedschedule',
  add_activity = 'add_activity',
  view_emailconfirmation = 'view_emailconfirmation',
  add_tasklog = 'add_tasklog',
  add_token = 'add_token',
  add_solarschedule = 'add_solarschedule',
  delete_permission = 'delete_permission',
  change_logentry = 'change_logentry',
  change_profile = 'change_profile',
  add_role = 'add_role',
  change_intervalschedule = 'change_intervalschedule',
  delete_tasklog = 'delete_tasklog',
  add_permissiondisplay = 'add_permissiondisplay',
  delete_role = 'delete_role',
  change_user = 'change_user',
  view_accesslog = 'view_accesslog',
  change_influence_diagram = 'change_influence_diagram',
  change_influence_diagram_public = 'change_influence_diagram_public',
  delete_solarschedule = 'delete_solarschedule',
  list_company_instances = 'list_company_instances',
  add_accessattempt = 'add_accessattempt',
  view_apppool = 'view_apppool',
  view_team = 'view_team',
  add_intervalschedule = 'add_intervalschedule',
  delete_socialaccount = 'delete_socialaccount',
  change_solarschedule = 'change_solarschedule',
  get_licence_info = 'get_licence_info',
  view_influence_diagram = 'view_influence_diagram',
  change_department = 'change_department',
  delete_emailconfirmation = 'delete_emailconfirmation',
  add_user = 'add_user',
  delete_chordcounter = 'delete_chordcounter',
  add_apppool = 'add_apppool',
  add_accesslog = 'add_accesslog',
  change_group = 'change_group',
  view_permission = 'view_permission',
  add_folder = 'add_folder',
  view_socialapp = 'view_socialapp',
  change_apppool = 'change_apppool',
  add_periodictask = 'add_periodictask',
  view_intervalschedule = 'view_intervalschedule',
  delete_crontabschedule = 'delete_crontabschedule',
  view_externallink = 'view_externallink',
  change_crontabschedule = 'change_crontabschedule',
  view_socialaccount = 'view_socialaccount',
  delete_files = 'delete_files',
  delete_accessattempt = 'delete_accessattempt',
  add_periodictasks = 'add_periodictasks',
  delete_emailqueue = 'delete_emailqueue',
  delete_preferencemodule = 'delete_preferencemodule',
  add_tokenproxy = 'add_tokenproxy',
  add_usercompany = 'add_usercompany',
  add_session = 'add_session',
  view_company_root = 'view_company_root',
  delete_accesslog = 'delete_accesslog',
  change_activity = 'change_activity',
  delete_company = 'delete_company',
  change_file_name_public = 'change_file_name_public',
  view_tokenproxy = 'view_tokenproxy',
  add_permission = 'add_permission',
  delete_file_public = 'delete_file_public',
  add_team = 'add_team',
  add_group = 'add_group',
  view_solarschedule = 'view_solarschedule',
  change_model = 'change_model',
  view_all_companies = 'view_all_companies',
  change_periodictasks = 'change_periodictasks',
  delete_activity = 'delete_activity',
  delete_apppool = 'delete_apppool',
  delete_companypreference = 'delete_companypreference',
  view_permissiondisplay = 'view_permissiondisplay',
  list_last_opened_apps = 'list_last_opened_apps',
  delete_intervalschedule = 'delete_intervalschedule',
  delete_departmentteam = 'delete_departmentteam',
  add_socialaccount = 'add_socialaccount',
  delete_contenttype = 'delete_contenttype',
  change_taskresult = 'change_taskresult',
  delete_taskresult = 'delete_taskresult',
  add_departmentteam = 'add_departmentteam',
  view_usercompany = 'view_usercompany',
  change_public_model = 'change_public_model',
  add_preference = 'add_preference',
  change_site = 'change_site',
  add_site = 'add_site',
  delete_department = 'delete_department',
  delete_user = 'delete_user',
  view_company = 'view_company',
  view_emailqueue = 'view_emailqueue',
  view_preference = 'view_preference',
  change_team = 'change_team',
  view_crontabschedule = 'view_crontabschedule',
  upload_file_public = 'upload_file_public',
  add_externallink = 'add_externallink',
  add_usercompanypreference = 'add_usercompanypreference',
  delete_emailaddress = 'delete_emailaddress',
  add_emailaddress = 'add_emailaddress',
  delete_periodictasklog = 'delete_periodictasklog',
  add_socialapp = 'add_socialapp',
  view_departmentteam = 'view_departmentteam',
  delete_socialtoken = 'delete_socialtoken',
  change_periodictask = 'change_periodictask',
  view_preferencemodule = 'view_preferencemodule',
  view_periodictasklog = 'view_periodictasklog',
  view_socialtoken = 'view_socialtoken',
  list_users = 'list_users',
  list_instances = 'list_instances',
  change_socialaccount = 'change_socialaccount',
  delete_group = 'delete_group',
  delete_periodictasks = 'delete_periodictasks',
  delete_usercompany = 'delete_usercompany',
  can_restrict_folders_modules_and_app_versions = 'can_restrict_folders_modules_and_app_versions',
  change_tasklog = 'change_tasklog',
  change_permission = 'change_permission',
  change_permissiondisplay = 'change_permissiondisplay',
  view_activity = 'view_activity',
  add_companypreference = 'add_companypreference',
  change_tokenproxy = 'change_tokenproxy',
  delete_token = 'delete_token',
  copy_model_to_my_workspace = 'copy_model_to_my_workspace',
  add_logentry = 'add_logentry',
  view_group = 'view_group',
  view_tasklog = 'view_tasklog',
  change_usercompany = 'change_usercompany',
  change_usercompanypreference = 'change_usercompanypreference',
  change_preferencemodule = 'change_preferencemodule',
  change_preference = 'change_preference',
  delete_periodictask = 'delete_periodictask',
  view_site = 'view_site',
  view_company_logs = 'view_company_logs',
  add_preferencemodule = 'add_preferencemodule',
  delete_externallink = 'delete_externallink',
  add_file_public = 'add_file_public',
  change_emailqueue = 'change_emailqueue',
  view_token = 'view_token',
  delete_clockedschedule = 'delete_clockedschedule',
  change_company = 'change_company',
  delete_site = 'delete_site',
  add_company = 'add_company',
  view_logentry = 'view_logentry',
  view_department = 'view_department',
  list_folders = 'list_folders',
  change_default_company_model = 'change_default_company_model',
  download_files = 'download_files',
  delete_usercompanypreference = 'delete_usercompanypreference',
  add_crontabschedule = 'add_crontabschedule',
  change_role = 'change_role',
  impersonate_user = 'impersonate_user',
  delete_session = 'delete_session',
  add_periodictasklog = 'add_periodictasklog',
  view_contenttype = 'view_contenttype',
  view_clockedschedule = 'view_clockedschedule',
  delete_logentry = 'delete_logentry',
  do_sanity_check = 'do_sanity_check',
  add_contenttype = 'add_contenttype',
  copy_file_or_folder = 'copy_file_or_folder',
  add_taskresult = 'add_taskresult',
  view_periodictask = 'view_periodictask',
  change_session = 'change_session',
  view_user = 'view_user',
  change_companypreference = 'change_companypreference',
  change_contenttype = 'change_contenttype',
  view_companypreference = 'view_companypreference',
  add_emailqueue = 'add_emailqueue',
  view_role = 'view_role',
  change_emailconfirmation = 'change_emailconfirmation',
  change_externallink = 'change_externallink',
  delete_preference = 'delete_preference',
  view_usercompanypreference = 'view_usercompanypreference',
  change_socialtoken = 'change_socialtoken',
  view_accessattempt = 'view_accessattempt',
  list_companies = 'list_companies',
  delete_team = 'delete_team',
  change_emailaddress = 'change_emailaddress',
  change_socialapp = 'change_socialapp',
  delete_permissiondisplay = 'delete_permissiondisplay',
  delete_instance = 'delete_instance',
  view_emailaddress = 'view_emailaddress',
  change_clockedschedule = 'change_clockedschedule',
  change_chordcounter = 'change_chordcounter',
  add_emailconfirmation = 'add_emailconfirmation',
  change_accessattempt = 'change_accessattempt',
  view_session = 'view_session',
  change_token = 'change_token',
  add_application = 'add_application',
  delete_application = 'delete_application',
  rename_application = 'rename_application',
  add_interface = 'add_interface',
  update_interface = 'update_interface',
  delete_interface = 'delete_interface',
  set_interface_permissions = 'set_interface_permissions',
  view_interface_manager = 'view_interface_manager',
  create_application_version = 'create_application_version',
  change_selected_application_version = 'change_selected_application_version',
  update_application_version_properties = 'update_application_version_properties',
  update_application_version_status = 'update_application_version_status',
  delete_application_version = 'delete_application_version',
  edit_application_technical_version = 'edit_application_technical_version',
  manage_processes = 'manage_processes',
  create_application_scenario = 'create_application_scenario',
  update_application_scenario_properties = 'update_application_scenario_properties',
  save_application_scenario = 'save_application_scenario',
  delete_application_scenario = 'delete_application_scenario',
  export_app_scenarios = 'export_app_scenarios',
  import_app_scenarios = 'import_app_scenarios',
  view_applications = 'view_applications',
  change_general_settings = 'change_general_settings',
  save_application_as = 'save_application_as',
  list_api_keys = 'list_api_keys',
  create_api_keys = 'create_api_keys',
  edit_api_keys = 'edit_api_keys',
  delete_api_keys = 'delete_api_keys',
  view_system_task = 'view_system_task',
  consolidate_applications = 'consolidate_applications',
  see_hidden_files = 'see_hidden_files',
  export_components = 'export_components',
  send_user_messages = 'send_user_messages',
  view_generalnotification = 'view_generalnotification',
  add_generalnotification = 'add_generalnotification',
  change_generalnotification = 'change_generalnotification',
  delete_generalnotification = 'delete_generalnotification',
  view_assistant_bot = 'view_assistant_bot',
  add_assistant_bot = 'add_assistant_bot',
  change_assistant_bot = 'change_assistant_bot',
  delete_assistant_bot = 'delete_assistant_bot',
  manage_secrets = 'manage_secrets',
  manage_libraries = 'manage_libraries',
  show_console = 'show_console',
  take_screenshot = 'take_screenshot',
  edit_app_documentation = 'edit_app_documentation',
  view_instance_logs = 'view_instance_logs',
  load_application_scenarios = 'load_application_scenarios',
  change_application_thumbnail = 'change_application_thumbnail',
  select_resources = 'select_resources',
  make_app_analysis = 'make_app_analysis',
  create_connection = 'create_connection',
  update_application_properties = 'update_application_properties',
  view_tests = 'view_tests',
  create_test = 'create_test',
  update_test = 'update_test',
  delete_test = 'delete_test',
  duplicate_test = 'duplicate_test',
  execute_tests = 'execute_tests',
  manage_test_settings = 'manage_test_settings',
  manage_test_applications = 'manage_test_applications',
  manage_test_applications_config = 'manage_test_applications_config',
  manage_system_secrets = 'manage_system_secrets',
  bulk_create_users = 'bulk_create_users',
  create_html_templates = 'create_html_templates',
  edit_html_templates = 'edit_html_templates',
  delete_html_templates = 'delete_html_templates',
  view_ai_traces = 'view_ai_traces',
  view_ai_management = 'view_ai_management',
  manage_ai_pricing = 'manage_ai_pricing'
}

export interface ChangeExpiredPasswordResponse {
  repeated: boolean
}

export interface NetworkDownNoMessageResponse {
  networkDown: boolean
}

export interface SetQRCodeResponse {
  otp_auth_url: string
}

export interface VerifyMFAAuthResponse {
  is_valid: boolean
}

export interface ImageTag {
  tag: string | null
  ui_tag: string | null
  api_tag: string | null
  engine_tag: string | null
}

export enum AuthErrorMessages {
  INVALID_CREDENTIALS = 'Invalid credentials',
  ACCOUNT_DISABLED = 'Account disabled',
  INVALID_INPUT = 'Invalid input',
  DIRECT_ACCESS_COMPANY_DENIED = 'Direct access company denied'
}

export interface AuthErrorData {
  code: AuthErrorMessages
  params?: Record<string, string>
}
